module.exports = __webpack_public_path__ + "static/img/16.967168c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/16.png
// module id = VB+4
// module chunks = 0